import React from 'react';
import { FormattedMessage } from 'react-intl';
import './Footer.scss';
import FooterTop from '../../../assets/images/Footer-top-border.svg';

const Footer = () => {
  return (
    <>
      <footer>
        <div className="FooterTop-container">
          <img src={FooterTop} className="footer-top" alt="Footer Top" />
        </div>
        <div className="Footer">
          <div className="container">
            <div>
              <span className="disclaimer_container">
                <p>
                  <FormattedMessage
                    id="footer.jdPowerPermission"
                    defaultMessage="EV solutions © 2026 J.D. Power, provided with permission."
                  />
                </p>
                <p>
                  <FormattedMessage
                    id="footer.estimatesDisclaimer"
                    defaultMessage="Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither J.D. Power® nor SMUD provide tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction."
                  />
                </p>
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
